import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us | Gandhi Mandela Foundation</title>

        <meta
          name="description"
          content="Gandhi Mandela Foundation is a Government of India-recognized NGO promoting peace, human rights, education, social welfare, humanitarian initiatives and global leadership inspired by Mahatma Gandhi and Nelson Mandela."
        />
        <meta
          name="keywords"
          content="Gandhi Mandela Foundation India, Gandhi Mandela Foundation Delhi, GMF India, GMF Non Profit Organization, Gandhi Mandela Foundation Awards, Gandhi Mandela Foundation, Gandhi Mandela Foundation NGO India, Social Welfare, Gandhi, GMF Nelson Mandela, GMF Charity, Donate"
        />

        <meta name="author" content="Gandhi Mandela Foundation" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="distribution" content="global" />
        <meta name="rating" content="general" />
        <meta name="revisit-after" content="7 days" />
        <meta name="theme-color" content="#d4a843" />
        <link rel="canonical" href="https://www.gandhimandelafoundation.com/" />
        <link
          rel="icon"
          type="image/x-icon"
          href="%PUBLIC_URL%/favicon/favicon.ico"
        />

        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="%PUBLIC_URL%/favicon/favicon-16x16.png"
        />

        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="%PUBLIC_URL%/favicon/favicon-32x32.png"
        />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="%PUBLIC_URL%/favicon/apple-touch-icon.png"
        />

        <link
          rel="icon"
          sizes="192x192"
          href="%PUBLIC_URL%/favicon/android-chrome-192x192.png"
        />

        <link
          rel="icon"
          sizes="512x512"
          href="%PUBLIC_URL%/favicon/android-chrome-512x512.png"
        />

        <link rel="manifest" href="%PUBLIC_URL%/favicon/site.webmanifest" />
      </Helmet>

      <Header />
      <div>
        <section className="page-header">
          <div className="container">
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span>/</span>
              <span>About Us</span>
            </div>
            <h1>About Us</h1>
          </div>
        </section>
        {/* =========================
        ABOUT US*/}
        <section className="section">
          <div className="container">
            <div className="grid grid-2">
              <div className="fade-in visible">
                <img
                  style={{ borderRadius: 18, boxShadow: "var(--card-shadow)" }}
                  src="img/gmf-about-img.jpg"
                  alt="About Foundation"
                />
              </div>
              <div className="fade-in visible">
                <h2 style={{ fontSize: 30, marginBottom: 10 }}>
                  GANDHI MANDELA FOUNDATION
                </h2>
                <p style={{ color: "var(--muted)", textAlign: "justify" }}>
                  The Gandhi Mandela Foundation (GMF) is a Government of
                  India–recognized trust, established to promote the timeless
                  values, ideals, and principles of Mahatma Gandhi and Nelson
                  Mandela, fostering global peace, non-violence, individual
                  freedom, civil liberties, and human rights.
                </p>
                <p
                  style={{
                    color: "var(--muted)",
                    marginTop: 12,
                    textAlign: "justify",
                  }}
                >
                  Headquartered in New Delhi, India, the Foundation has a strong
                  and expanding global presence across more than 20 countries,
                  including India, Nepal, United Kingdom, Ukraine, Malaysia,
                  South Africa, Bangladesh, United States of America, Canada,
                  Bolivia, Mexico, Sri Lanka, Russia, Australia, Spain,
                  Colombia, Panama, Brazil, Argentina, Cuba, Venezuela, Costa
                  Rica, Italy, Dominican Republic, and Madagascar.
                </p>
                <p
                  style={{
                    color: "var(--muted)",
                    marginTop: 12,
                    textAlign: "justify",
                  }}
                >
                  The Foundation has had the privilege of organizing prestigious
                  international initiatives in collaboration with United Nations
                  agencies, as well as embassies and high commissions across the
                  world. GMF has also received global recognition from reputed
                  international media, including Time Magazine, for its
                  impactful peace-building efforts.
                </p>
                <p
                  style={{
                    color: "var(--muted)",
                    marginTop: 12,
                    textAlign: "justify",
                  }}
                >
                  The Gandhi Mandela Foundation organizes one of the world’s
                  most prestigious honors—the Gandhi Mandela Award—which is
                  conferred upon eminent global leaders who have dedicated their
                  lives to peace, freedom, humanitarian service, and the
                  upliftment of humanity. The inaugural award was presented to
                  His Holiness Dalai Lama, followed by Rigoberta Menchú Tum, a
                  Nobel Peace Laureate and advocate of indigenous rights.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="section-title">
              <h2>International Jury Members</h2>
              <p>
                The distinguished International Jury for the award includes:
              </p>
            </div>
            <div className="jury-list">
              <div className="jury-item">
                <h4>Justice K. G. Balakrishnan</h4>
                <p>
                  Jury Chairman, Former Chief Justice of India &amp; Former
                  Chairman, NHRC India.
                </p>
              </div>
              <div className="jury-item">
                <h5
                  style={{
                    marginTop: "10px",
                    marginBottom: "-12px",
                    paddingBottom: "10px",
                  }}
                >
                  (Nobel Peace Prize Winner - 1992)
                </h5>
                <h4>Rigoberta Menchú Tum</h4>
                <p>
                  Nobel Peace Prize Laureate and internationally recognized
                  human rights activist.
                </p>
              </div>
              <div className="jury-item">
                <h4>Norma Lucía Piña Hernández</h4>
                <p>Former Chief Justice of the Mexican Supreme Court.</p>
              </div>
              <div className="jury-item">
                <h4>Justice Kedar Nath Upadhyay</h4>
                <p>
                  Former Chief Justice of Nepal &amp; Former Chairman, NHRC
                  Nepal.
                </p>
              </div>
              <div className="jury-item">
                <h4>Justice Md. Tafazzul Islam</h4>
                <p>Former Chief Justice of Bangladesh.</p>
              </div>
              <div className="jury-item">
                <h4>Justice Gyan Sudha Misra</h4>
                <p>Former Judge of the Supreme Court of India.</p>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
        ABOUT US end*/}
        <Footer />
      </div>
    </>
  );
}
